<template>
  <div class="mainBody">
    <div class="desktopMenu">
      <div class="landingLogo">
        <a href="">
          <img :src="imgLogo" alt="">
        </a>
      </div>
      <div class="login">
        <!--
                <a href="#contact" class="contact center">Contact</a>
        -->
        <a href="#" class="contact customcenter" v-scroll-to="{
           el: '#contact',
           duration: 1500,
           x: false,
           y: true
         }">
          Contact
        </a>
        <md-button class="md-dense md-raised customcenter" @click="toLogin">Log In or Register</md-button>
      </div>

    </div>

    <div class="mobileMenu">
      <div class="page-container md-layout-column">
        <div class="landingLogo">
          <a href="">
            <img :src="imgLogo" alt="">
          </a>
        </div>
        <div class="md-primary">
          <div class="md-toolbar-section-end">
            <md-button @click="showSidepanel = true">
              <md-icon>menu</md-icon>
            </md-button>
          </div>
        </div>

        <md-drawer class="md-right" :md-active.sync="showSidepanel">
          <div style="margin-top: 10%">
            <div class="mobileLogin">
              <md-button style="text-transform: none;" class="md-dense md-raised customcenter" @click="toLogin">Log In or
                Register
              </md-button>
            </div>
            <div style="text-align: center">
              <a href="#" class="contact center" v-scroll-to="{
                el: '#contact',
                duration: 1500,
                x: false,
                y: true
               }">
                Contact
              </a>
            </div>

          </div>
        </md-drawer>
      </div>
    </div>
    <br>
    <div>
      <p class="titleContent">Blood Donors' Network</p>
      <br>
      <p class="headerText">inspired by the spirit of those who care for other & enjoy <br> lending a hand to those who
        are in need.</p>
    </div>

    <div style="text-align: center">
      <img :src="headerImage" alt="">
    </div>
    <div class="background">
      <p class="bodyTitle">Donate the Drops that Count</p>
      <br>
      <p class="bodyTitleCaption">The most interactive platform to help people find & donate blood</p>
      <br>
      <div style="width: 70%; margin: 0 auto">
        <p class="bodyText">
          BDNBD - Blood Donor Network Bangladesh is designed to build a community of people who are self-driven to help each other by donating blood. We felt the complexity of finding a donor with the right match in an emergency situation. And sometimes it is too expensive to buy a bag of blood from the blood bank. We are tired of the process of calling a thousand people for a bag of blood and obsessed with not finding any donor.
          This is what inspired us to develop BDNBD, an intuitive and interactive platform to donate and search for blood at any time at any place, even if you are on a 2G network.
          BDNBD is developed under a highly secured environment and privacy policy that delivers a better user experience preserving all the data security of the users. The platform is a global network of people all around the world to build global harmony.
        </p>
      </div>
    </div>
    <div>
      <p class="downloadTitle">Experience More with Our App</p>
      <br>
      <p class="downloadTitleCaption">download the most interactive app and unlock more power to help people</p>
      <br>
      <div style="text-align: center">
        <img :src="downloadImage" alt="">
      </div>
      <div style="text-align: center">
        <a href="https://bdnbd.page.link/app" target="_blank">
          <img :src="playstoreImage" alt="">
        </a>
      </div>
    </div>
    <div class="background">
      <p class="donateTitle">Join the Force</p>
      <br>
      <p class="donateTitleCaption">Your little donation can help us to make bdnbd more intuitive</p>
      <br>
      <div style="text-align: center">
        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
          <input type="hidden" name="cmd" value="_s-xclick"/>
          <input type="hidden" name="hosted_button_id" value="PZCUX4PNCT6D4"/>
          <button class="hideButton">
            <img :src="donateButtonImage" alt="">
          </button>
        </form>
      </div>
      <div style="text-align: center">
        <img :src="donateCardImage" alt="">
      </div>
    </div>
    <div id="contact">
      <p class="contactTitle">Feel Free to Contact Us</p>
      <br>
      <p class="contactTitleCaption">we listen everything you have to say. just send us a message</p>
      <br>

      <form class="formDesign">
        <input type="text" placeholder="Full Name" v-model="fullname" required>
        <input type="email" placeholder="Email" v-model="email">
        <input type="text" placeholder="Subject" v-model="subject">
        <textarea style="height: 219px;font-family: Roboto" placeholder="Write your message here"
                  v-model="body"></textarea>
        <div id="errormsg" v-if="message == 'Error'" class="errorMeassage"><p>Invalid Information</p></div>
        <div id="successmsg" v-if="message == 'Success'" class="successMeassage"><p>Thanks for contact with us</p></div>
        <br>
        <div class="contactButton">
          <md-button class="md-dense md-raised customcenter" @click="contactUs">Send Your Message</md-button>
        </div>
        <br>
      </form>
    </div>

    <div class="landingFooter">
      <p>
        All Right Reserved <span style="font-size: 16px">©</span>
        <a href="bdnbd.net" target="_blank" style="text-decoration: none; color: #878787">
          bdnbd.net
        </a>
        &nbsp| &nbsp
        <span style="font-weight: 500">
          Sponsored & Developed by
          <a href="https://www.authenticsoft.net/" target="_blank" style="color: #FF5454">Authentic Software</a>
          &nbsp | &nbsp
          <span @click="privacyPolicy" style="cursor: pointer">
            Privacy Policy
          </span>
        </span>
      </p>
    </div>

  </div>
</template>
<script>


  export default {
    data: () => ({
      showSidepanel: false,
      fullname: '',
      email: '',
      subject: '',
      body: '',
      message: ''
    }),

    props: {

      imgLogo: {
        type: String,
        default: require('@/assets/img/landing/logo.png')
      },
      headerImage: {
        type: String,
        default: require('@/assets/img/landing/headerimage.png')
      },
      downloadImage: {
        type: String,
        default: require('@/assets/img/landing/app_review_img.png')
      },
      playstoreImage: {
        type: String,
        default: require('@/assets/img/landing/google_play btn.png')
      },
      donateButtonImage: {
        type: String,
        default: require('@/assets/img/landing/donate_btn.png')
      },
      donateCardImage: {
        type: String,
        default: require('@/assets/img/landing/donate_bdnbd.png')
      }

    },
    methods: {
      toLogin() {
        console.log('asd')
        let routeData = this.$router.resolve({name: 'Login'});
        window.open(routeData.href, '_blank');
      },
      privacyPolicy() {
        console.log('asd')
        this.$router.push({name: 'PrivacyPolicy'});
      },
      contactUs() {
        let self = this;
        let contactUsData = {
          fullname: this.fullname,
          email: this.email,
          subject: this.subject,
          body: this.body

        };
        this.$store.dispatch('ContactUs', contactUsData)
          .then((response) => {
            self.message = 'Success';
            setTimeout("location.href = '/'",3000);

          })
          .catch((error) => {
            self.message = 'Error';

            console.log("error", self.message)
          })
        this.edit = false
      }

    }
  }
</script>
<style>
  @font-face {
    font-family: customFont;
    src: url('../assets/font/LBRITED.TTF');
  }

  .errorMeassage {
    color: red;
    border: 1px solid red;
    width: 60%;
    margin: 0 auto;
    margin-top: 5%;
    height: 50px;
    border-radius: 10px;
    background-color: rgba(255, 0, 0, 0.11);
    -webkit-animation: fadein 2s;
    -moz-animation: fadein 2s; /* Firefox < 16 */
    -ms-animation: fadein 2s; /* Internet Explorer */
    -o-animation: fadein 2s; /* Opera < 12.1 */
    animation: fadein 2s;

  }
  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .errorMeassage p{
    margin-top: 2%;
  }
  .successMeassage{
    color: green;
    border: 1px solid green;
    width: 60%;
    margin: 0 auto;
    margin-top: 5%;
    height: 50px;
    border-radius: 10px;
    background-color: rgba(73, 128, 0, 0.11);
    -webkit-animation: fadein 2s;
    -moz-animation: fadein 2s; /* Firefox < 16 */
    -ms-animation: fadein 2s; /* Internet Explorer */
    -o-animation: fadein 2s; /* Opera < 12.1 */
    animation: fadein 2s;
  }
  .successMeassage p{
    margin-top: 2%;
  }

  .landingLogo {
    position: relative !important;
    padding: 0px !important;
    margin: 2% !important;
    z-index: 4 !important;
    float: left;
  }

  .login {
    position: relative !important;
    padding: 0px !important;
    margin: 2% !important;
    z-index: 4 !important;
    float: right;
    display: inline-block;
  }

  .customcenter {
    width: 180px; /* Can vary too */
    margin: 25px -35px;

    display: inline-block;
    white-space: normal;
    vertical-align: middle;
    text-align: center;
  }

  .titleContent {
    font-family: customFont;
    text-align: center;
    margin-top: 10%;
    font-size: 48px;
    font-weight: 500;
    color: #404040;
    line-height: 1em;
  }

  .headerText {
    text-align: center;
    font-size: 20px;
    color: #404040;
  }

  .bodyTitle {
    font-family: customFont;
    text-align: center;
    margin-top: 2%;
    font-size: 34px;
    color: #FF5454;
    font-weight: 500;
    line-height: 1em;
  }

  .bodyTitleCaption {
    text-align: center;
    font-size: 20px;
    color: #878787;
  }

  .bodyText {
    text-align: center;
    font-size: 14px;
    color: #404040;
  }

  .background {
    background-color: #F9F9F9;
    padding-top: 5%;
    padding-bottom: 5%;
    margin-top: 5%;
  }

  .downloadTitle {
    font-family: customFont;
    text-align: center;
    margin-top: 5%;
    font-size: 34px;
    color: #404040;
    font-weight: 500;
    line-height: 1em;
  }

  .downloadTitleCaption {
    text-align: center;
    font-size: 20px;
    color: #404040;

  }

  .donateTitle {
    font-family: customFont;
    text-align: center;
    font-size: 24px;
    color: #404040;
    font-weight: 500;
    line-height: 1em;
  }

  .donateTitleCaption {
    text-align: center;
    font-size: 20px;
    color: #878787;

  }

  .contactTitle {
    font-family: customFont;
    text-align: center;
    margin-top: 5%;
    font-size: 34px;
    color: #404040;
    font-weight: 500;
    line-height: 1em;

  }

  .contactTitleCaption {
    text-align: center;
    font-size: 20px;
    color: #404040;
  }

  .formDesign {
    text-align: center;
    width: 60%;
    margin: 0 auto
  }

  input, textarea {
    width: 60%;
    border-radius: 10px;
    background-color: #F1F1F1;
    padding: 20px;
    margin-top: 3%;
    border-width: 0px;
  }

  /*.contactButton{
    position: relative !important;
    padding: 0px !important;
    z-index: 4 !important;
    float: left;
    display: inline-block;
    width: 60%;
  }*/
  .contactButton .md-button {
    background-color: #4689FF !important;
    text-transform: none;
    border-radius: 10px;
    width: 60% !important;
    height: 49px !important;
    margin-bottom: 5%;
    margin-top: 3%;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.16) !important;
  }

  .contactButton .md-button:hover {
    background-color: rgba(70, 137, 255, 0.81) !important;
  }

  body {
    background-color: #ffffff !important;
  }

  html.md-theme-default {
    background-color: #ffffff !important;
  }

  .login .md-button {
    background-color: #4689FF !important;
    text-transform: none;
    border-radius: 10px;
    width: 165px !important;
    height: 49px !important;
  }

  .login .md-button:hover {
    background-color: rgba(70, 137, 255, 0.81) !important;
  }

  .login a {
    font-size: 14px;
    color: #373737 !important;
    font-weight: 400;
  }

  .login a:hover {
    color: rgba(55, 55, 55, 0.81) !important;
  }

  .login a:active {
    color: #373737 !important;
  }

  .mobileLogin {
    text-align: center;
  }

  .mobileLogin .md-button {
    background-color: #4689FF !important;
    text-transform: none;
    border-radius: 10px
  }

  .mobileLogin .md-button:active {
    background-color: rgba(70, 137, 255, 0.81) !important;
  }

  .landingFooter {
    text-align: center;
    background-color: #F1F1F1;
    margin-top: 5%;
    padding: 2%;

  }

  .landingFooter p {
    font-weight: 400;
    color: #878787
  }

  .hideButton {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  @media only screen and (max-width: 992px) {
    .titleContent {
      font-size: 34px;
      margin-top: 15%;
    }

    .bodyTitle {
      font-size: 28px;
    }

    .formDesign {
      width: 90%;
    }
  }

  @media only screen and (max-width: 768px) {
    input, textarea {
      width: 90%;
    }

    .formDesign {
      width: 100%;
    }

    .contactButton .md-button {
      width: 90% !important;

    }

    .titleContent {
      padding: 3%;
    }

    .headerText {
      padding: 5%;
    }

    .bodyTitle {
      padding: 5%;
    }

    .bodyTitleCaption {
      padding: 5%;
    }

    .downloadTitle {
      padding: 5%;
    }

    .downloadTitleCaption {
      padding: 5%;
    }

    .donateTitle {
      padding: 5%;
    }

    .donateTitleCaption {
      padding: 5%;
    }

    .contactTitle {
      padding: 5%;
    }

    .contactTitleCaption {
      padding: 5%;
    }

    .desktopMenu {
      display: none;
    }

    .landingFooter {
      padding: 4%;
    }
  }

  @media (min-width: 769px) {
    .mobileMenu {
      display: none;
    }
  }


</style>
